module.exports = __webpack_public_path__ + "img/zanwujiaofeijilu@3x.ad52db7d.png";